import moment from 'moment';

const dateFormat = 'YYYYMMDD';
export const defaultTypes = {
  id: 0,
  name: '',
  description: '',
  status: '',
  type: '',
  subStatus: 'current',
  isBillable: true,
  isOnBoardingProject: false,
  isSampleProject: false,
  isPrivate: false,
  company: {
    id: 0,
    name: '',
  },
  startDate: moment.tz('', dateFormat, moment.tz.guess()),
  endDate: moment.tz('', dateFormat, moment.tz.guess()),
  minMaxAvailableDates: {
    suggestedEndDate: moment.tz('', dateFormat, moment.tz.guess()),
    suggestedStartDate: moment.tz('', dateFormat, moment.tz.guess()),
  },
  activePages: {
    links: false,
    tasks: false,
    time: false,
    finance: false,
    notebooks: false,
    files: false,
    comments: false,
    messages: false,
    milestones: false,
    riskRegister: false,
    list: false,
    table: false,
    board: false,
    gantt: false,
    forms: false,
  },
  permissions: {
    canAddTaskLists: false,
    canManageProjectBudget: false,
    canViewProjectBudget: false,
    viewNotebook: false,
    canAccessSharepoint: false,
    canAccessOneDriveBusiness: false,
    receiveEmailNotifications: false,
    projectAdministrator: false,
    canAddLinks: false,
    viewMessagesAndFiles: false,
    canAddMessages: false,
    isObserving: false,
    canAccess: false,
    canEditAllTasks: false,
    canAccessMicrosoftConnectors: false,
    canAccessBox: false,
    viewTimeLog: false,
    canSetPrivacy: false,
    canAddNotebooks: false,
    viewLinks: false,
    isArchived: false,
    viewTasksAndMilestones: false,
    viewEstimatedTime: false,
    viewAllTimeLogs: false,
    canLogTime: false,
    canAddMilestones: false,
    canAccessDropbox: false,
    canAddFiles: false,
    canAccessGoogleDocs: false,
    canAccessInvoiceTracking: false,
    viewRiskRegister: false,
    canAddRisks: false,
    canAddTasks: false,
    active: false,
    canAccessOneDrive: false,
    canAddProjectUpdate: false,
    canViewForms: false,
    canAddForms: false,
    canManageCustomFields: false,
  },
  category: {
    color: '',
    id: 0,
    name: '',
  },
  customFields: [],
  skipWeekends: false,
  projectOwnerId: 0,
  starred: false,
  startPage: 'projectoverview',
  overviewStartPage: 'default',
  tasksStartPage: 'default',
  dateLastActive: moment('', 'YYYY-MM-DDTHH:mm:ssZ'),
  logo: '',
  tags: [],
  owner: {
    id: 0,
    firstName: '',
    lastName: '',
    fullName: '',
  },
};

export const defaults = {
  ...defaultTypes,
  startDate: null,
  endDate: null,
  dateLastActive: null,
};
